import Konva from '../../../konva';

import { CHANGE_ROTATION } from '../actions/changeRotation';
import { CLEAR_FINETUNE } from '../actions/clearFinetune';
import { SET_RESIZE } from '../actions/setResize';
import { Warmth as CustomWarmth } from '../custom/finetunes';
import { TOOLS_IDS } from './constants';
import getSizeAfterRotation from './getSizeAfterRotation';

const EPSILON = 0.001;

const FINETUNE_TOOL_CONFIG = {
  [TOOLS_IDS.BRIGHTNESS]: {
    finetune: Konva.Filters.Brighten,
    defaultProps: { brightness: 0 },
    isApplied: (props) => Math.abs(props.brightness ?? 0) > EPSILON,
  },
  [TOOLS_IDS.CONTRAST]: {
    finetune: Konva.Filters.Contrast,
    defaultProps: { contrast: 0 },
    isApplied: (props) => Math.abs(props.contrast ?? 0) > EPSILON,
  },
  [TOOLS_IDS.BLUR]: {
    finetune: Konva.Filters.Blur,
    defaultProps: { blurRadius: 0 },
    isApplied: (props) => (props.blurRadius ?? 0) > 0,
  },
  [TOOLS_IDS.WARMTH]: {
    finetune: CustomWarmth,
    defaultProps: { warmth: 0 },
    isApplied: (props) => (props.warmth ?? 0) > 0,
  },
  [TOOLS_IDS.HSV]: {
    finetune: Konva.Filters.HSV,
    defaultProps: { hue: 0, saturation: 0, value: 0 },
    isApplied: (props) =>
      (props.hue ?? 0) !== 0 ||
      Math.abs(props.saturation ?? 0) > EPSILON ||
      Math.abs(props.value ?? 0) > EPSILON,
  },
};

export function isAdjustToolApplied(toolId, { adjustments = {}, finetunesProps = {} } = {}) {
  if (toolId === TOOLS_IDS.ROTATE) {
    return Math.abs(adjustments.rotation ?? 0) > EPSILON;
  }

  const config = FINETUNE_TOOL_CONFIG[toolId];
  return config ? config.isApplied(finetunesProps) : false;
}

export function canResetAdjustTool(toolId) {
  return toolId === TOOLS_IDS.ROTATE || Boolean(FINETUNE_TOOL_CONFIG[toolId]);
}

export function getAdjustToolResetActions(
  toolId,
  { resize = {} } = {},
) {
  if (toolId === TOOLS_IDS.ROTATE) {
    const actions = [
      {
        type: CHANGE_ROTATION,
        payload: { rotation: 0 },
      },
    ];

    if (resize.width && resize.height) {
      const sizeAfterRotation = getSizeAfterRotation(
        resize.width,
        resize.height,
        0,
      );
      actions.push({
        type: SET_RESIZE,
        payload: {
          width: sizeAfterRotation.width,
          height: sizeAfterRotation.height,
        },
      });
    }

    return actions;
  }

  const config = FINETUNE_TOOL_CONFIG[toolId];
  if (!config) {
    return [];
  }

  return [
    {
      type: CLEAR_FINETUNE,
      payload: {
        finetune: config.finetune,
        defaultProps: config.defaultProps,
      },
    },
  ];
}
